import { FC } from 'react'
import { App } from './App.tsx'

export const MoveApp: FC = () => <App />
